import { render } from "./Avatar.vue?vue&type=template&id=739614d2&scoped=true"
const script = {}

import "./Avatar.vue?vue&type=style&index=0&id=739614d2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-739614d2"]])

export default __exports__